import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";
import { ConfiguracioService } from "../services/configuracio.service";

class Component {
  centre: any;
  resolve: any;
  selectorCurs: string;
  ofertaCentreSFP: any;
  increment: number = 1;
  isOferta: boolean = false;
  isProgramacio: boolean = false;
  areBoth: boolean = false;
  teProgramacio: boolean = false;
  anyActual: number;
  anyActualString: string;
  anyActualMesU: number;
  anyActualMesUString: string;
  anyActualMesDos: number;
  periodeAct: string;
  periodeSeg: string;
  modalInstance: ng.ui.bootstrap.IModalInstanceService;

  constructor(private Configuracio: ConfiguracioService) {}

  $onInit() {
    this.centre = this.resolve.centre;
    this.ofertaCentreSFP = this.resolve.ofertaCentreSFP;
    this.selectorCurs = this.resolve.selectorCurs;
    this.initializeYears();
    this.initViewState();
    this.processOfertes();
  }

  // Initialize year-based variables
  private initializeYears(): void {
    this.anyActual = parseInt(this.Configuracio.getConfiguracio().anyActual, 10);
    this.anyActualString = `'${String(this.anyActual)}'`;
    this.anyActualMesU = this.anyActual + this.increment;
    this.anyActualMesUString = `'${String(this.anyActualMesU)}'`;
    this.anyActualMesDos = this.anyActualMesU + this.increment;
    this.periodeAct = `${this.anyActual} - ${this.anyActualMesU}`;
    this.periodeSeg = `${this.anyActualMesU} - ${this.anyActualMesDos}`;
  }

  // Determine the state of oferta, programacio, or both
  private initViewState(): void {
    if (this.selectorCurs === this.anyActualString) {
      this.isOferta = true;
    } else if (this.selectorCurs === this.anyActualMesUString) {
      this.isProgramacio = true;
    } else {
      this.areBoth = true;
    }
  }

  // Process the oferta data
  private processOfertes(): void {
    (this.ofertaCentreSFP.ofertes || []).forEach((oferta: any) => {
      oferta.isOfertaActual = false;
      oferta.isSFPActual = false;

      if (oferta.anyActivacioOferta === this.anyActualMesU) {
        oferta.isOfertaVinent = 3;
        if (this.Configuracio.getConfiguracio().progEnabled === '1') {
          this.teProgramacio = true;
        }
      } else {
        oferta.isOfertaVinent = 2;
      }

      oferta.isSFPVinent = false;

      oferta.ofertaEnsenyament.forEach((ensenyament: any) => {
        if (+ensenyament.curs === this.anyActual) {
          oferta.isOfertaActual = true;
          if (ensenyament.SFP === 'S') {
            oferta.isSFPActual = true;
          }
        } else if (+ensenyament.curs === this.anyActualMesU) {
          oferta.isOfertaVinent = 1;
          if (this.Configuracio.getConfiguracio().progEnabled === '1') {
            this.teProgramacio = true;
          }
          if (ensenyament.SFP === 'S') {
            oferta.isSFPVinent = true;
          }
        }
      });
    });
  }

  // Close the modal
  ok(): void {
    this.modalInstance.close();
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    modalInstance: "<",
    resolve: "<",
  },
  templateUrl: './components/modal-centres-sfp.component.html',
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.CENTRES_SFP, component);
